/**
 * recommendations on product/search/category pages
 * @dependency
 */
define([], function() {

	var RRModule = {

		/**
		 * gets the value for C_CLIENT_SESSION_ID cookie
		 * if value of cookie is not set then gets a generated one
	     * @return {[string]} the value for C_CLIENT_SESSION_ID cookie
		 */
		getClientSessionId : function() {

			var clientSessionId = $.cookie('C_CLIENT_SESSION_ID');

			if (clientSessionId == null || clientSessionId == '' || clientSessionId == '""') {
				clientSessionId = RRModule.getUUID();
				$.cookie('C_CLIENT_SESSION_ID', clientSessionId);
			}

			return clientSessionId;

		},

		/**
		 * generates a UUID string
	     * @return {[string]} a generated UUID
		 */
		getUUID : function() {

			var nbr, randStr = "";
			do {
				randStr += (nbr = Math.random()).toString(16).substr(2);
			}
			while (randStr.length < 30);

			return [randStr.substr(0, 8),"-",randStr.substr(8, 4), "-4",randStr.substr(12, 3), "-",
					((nbr*4|0)+8).toString(16), randStr.substr(15, 3), "-",randStr.substr(18, 12)].join("");
		},

		/**
	     * @return {[void]}
		 */
		prepareRequest : function() {

			var sessionId = RRModule.getClientSessionId();
			var userId = $.cookie('hashedUserId');
			var pageType = rrData.pageType.toLowerCase();

			//set global R3_COMMON properties
			R3_COMMON = new r3_common();
			R3_COMMON.setApiKey(rrData.apiKey);
			R3_COMMON.setBaseUrl(window.location.protocol + rrData.baseUrl);
			R3_COMMON.setClickthruServer(window.location.protocol + "//" + window.location.host);
			R3_COMMON.setSessionId(sessionId);
			if (userId != null && typeof userId != 'undefined' && userId != '""') {
				R3_COMMON.setUserId(userId);
			}

			//set page specific properties
			switch (pageType) {
				case 'home':
					//R3_HOME = new r3_home();
					break;

				case 'product':
					R3_ITEM = new r3_item();
					R3_ITEM.setId(rrData.productId);
					R3_ITEM.setName(rrData.productName);
					R3_COMMON.addCategoryHintId(rrData.categoryId);
					R3_COMMON.addPlacementType('item_page.json');
					break;

				case 'category':
					R3_CATEGORY = new r3_category();
					R3_CATEGORY.setId(rrData.categoryId);
					R3_CATEGORY.setName(rrData.categoryName);
					$('[itemid]').slice(0,15).each(function(){
						R3_COMMON.addItemId($(this).attr('itemid'));
					});
					R3_COMMON.addPlacementType('category_page.json');
					break;

				case 'search':
					R3_SEARCH = new r3_search();
					R3_SEARCH.setTerms(rrData.searchTerm);
					R3_COMMON.searchTerms = rrData.searchTerm;
					R3_COMMON.addPlacementType('search_page.json');
					break;

				case 'cart':
					R3_CART = new r3_cart();
					// Adding all of the items from the cart for RR
					R3_CART.addItemId.apply(R3_CART,
						$('.itemPartNumberInCart').map(function(i, div) {
							return $(div).text().trim();
						})
					);
					R3_COMMON.addPlacementType('cart_page.json')
					break;

				case 'purchasecomplete':
					R3_PURCHASED = new r3_purchased();
					R3_PURCHASED.setOrderNumber(rrData.orderId);
					
					if(typeof(digitalData) != 'undefined'){
						for(var i=0;i<digitalData.cart.products.length;i++){
							var product = digitalData.cart.products[i]; 
							R3_PURCHASED.addItemIdPriceQuantity(product.id, product.price, product.quantity);
						}
						
						 //
					}
					break;

			}

			/**
			 * @return {[void]}
			 */
			RR.jsonCallback = function() {

				var placementResponse = null;

				//check for response data
				try {
					placementResponse = RR.data.JSON.placements.length;
				}
				catch(e) {
					COSTCO.Global.logger('RR - no response data. Recommended products not available.');
				}

				if (placementResponse) { //handle JSON response data
					var placement = RR.data.JSON.placements[0];
					var placementName = placement.placement_name;
					var items = placement.items;
					var message = placement.message; //header message for recommended products
					var rrDiv = $('#rr-placement');
					var elementArr = []; //create array of elements to insert later into DOM at once
					elementArr.push('<h3>' + message + '</h3>');

					//loop through items and build product tiles with template
					for (var i = 0; i < items.length; i++) {
						var current = $(COSTCO.util.tmpl('tmpl_product_tile', {
							linkURL: items[i].linkURL.trim(),
							imageURL: items[i].imageURL.trim().replace('/150-', '/300-'),
							price: items[i].price.trim(),
							merch_desc: items[i].merch_desc.trim(),
							name: items[i].name.trim(),
							rating: items[i].rating.trim(),
							ratingClip: items[i].rating.trim() * 18,
							reviews: (items[i].reviews.length ? items[i].reviews.trim() : 0)
						}));
						current.addClass('rrTile');
						elementArr.push(current.prop('outerHTML'));
					}

					//insert the elements into rrDiv and add properties for creating carousel
					rrDiv.prepend(elementArr.join(''));
					rrDiv.find('.rrTile').wrapAll('<div class="feature-carousel" id="rr-carousel" />');
					rrDiv.addClass('fixed-container product-list feature-carousel-container');
					if (pageType != 'product' && pageType != 'cart') {
						rrDiv.append('<hr>');
					}
					if (pageType == 'cart') {
						rrDiv.prepend('<hr>');
					}

					COSTCO.util.carousel('#rr-carousel', {
						dots: true,
						arrows: true,
						infinite: false,
						slidesToShow: 4,
						slidesToScroll: 4,
						autoplay: false,
						lazyLoad: 'ondemand',
						responsive : [{
							breakpoint: 667,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2,
								dots: true,
								infinite: false,
								arrows: false
							}
						}]
					});
					COSTCO.util.display_member_prices();
					$('#rr-placement').show();
				}
			}

		},

		/**
		 * JSON response data
	     * @return {[void]}
		 */
		sendRequest : function() {

			RRModule.prepareRequest();
			rr_flush_onload();
			r3();

		},

		/**
	     * @return {[void]}
		 */
		initialize : function() {

			COSTCO.Global.logger('RR - Initializing');

			if (typeof(rrData) == 'undefined') {
				COSTCO.Global.logger('RR - rrData not found. Exiting');
				return;
			}
			if (rrData.rrEnabled == '0' || rrData.pageType == 'NoTracking') {
				COSTCO.Global.logger('RR - Disabled/NoTracking turned on. Exiting');
				return;
			}
			
			if(rrData.pageType != 'PurchaseComplete'){
				if (!$('#rr-placement').length) {
					COSTCO.Global.logger('RR - no placement found. Exiting');
					return;
				}
				
				var initialized = false;
				var rrHandler = COSTCO.util.onVisibilityChange($('#rr-placement'), function() {
					if (initialized) { return; }
					
					$(window).unbind('scroll.rrHandler');

					console.log('RR Div in view and Firing Handler');

					$.cachedScript(rrData.scriptUrl).done(function(script, textStatus) {
						COSTCO.Global.logger('RR - loaded script ' + textStatus);
						RRModule.sendRequest();
					});
					initialized = true;
				});

				//jQuery
				$(window).on('load scroll.rrHandler', rrHandler);
				
			}else{
				
				console.log('RR Div in view and Firing Handler');

				$.cachedScript(rrData.scriptUrl).done(function(script, textStatus) {
					COSTCO.Global.logger('RR - loaded script ' + textStatus);
					RRModule.sendRequest();
				});
				initialized = true;
			
			}
			


		}
	}

	function load() {
		RRModule.initialize();
	}

	if (typeof window.COSTCO == 'undefined') {
		window.COSTCO = new Object();
	}
	if (typeof window.COSTCO.Global == 'undefined') {
		document.addEventListener("CostcoGlobalLoaded", load, false);
	}
	else {
		load();
	}

});



// WEBPACK FOOTER //
// ./js/global/rrvndr.js